<template>
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group" role="group">
      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('grin'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('grin')"
              @click.prevent="react('grin', 'reply')">
        <i class="far fa-grin" />
        {{ reactionsCount('grin') }}
      </button>

      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('thumbs-up'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('thumbs-up')"
              @click.prevent="react('thumbs-up', 'reply')">
        <i class="far fa-thumbs-up" />
        {{ reactionsCount('thumbs-up') }}
      </button>

      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('thumbs-down'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('thumbs-down')"
              @click.prevent="react('thumbs-down', 'reply')">
        <i class="far fa-thumbs-down" />
        {{ reactionsCount('thumbs-down') }}
      </button>

      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('check'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('check')"
              @click.prevent="react('check', 'reply')">
        <i class="fas fa-check" />
        {{ reactionsCount('check') }}
      </button>

      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('heart'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('heart')"
              @click.prevent="react('heart', 'reply')">
        <i class="fas fa-heart" />
        {{ reactionsCount('heart') }}
      </button>

      <button :class="['btn', 'btn-light', 'emo', { 'own-tooltip own-tooltip-bottom' : reactionUsersList('eye'), 'readonly' : this.$props.readonly }]"
              :data-tooltip="reactionUsersList('eye')"
              @click.prevent="react('eye', 'reply')">
        <i class="fas fa-eye" />
        {{ reactionsCount('eye') }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false
      }
    },
    props: {
      message: {
        type: Object,
        required: true
      },
      messageType: {
        type: String,
        required: true
      },
      users: {
        type: Array,
        required: true
      },
      readonly: {
        type: Boolean,
        default: () => { return false }
      }
    },
    computed: {
      reactions(){
        return this.message.reactions || []
      }
    },
    methods: {
      reactionsCount(name){
        let user_ids = this.reactions[name] || []
        let count = user_ids.length
        if(count > 0)
            return user_ids.length
        else
            return ''
      },
      reactionUsersList(name){
        let user_ids = this.reactions[name] || []
        let users = this.users || []

        return users.filter(user => {
          if(user_ids.includes(user.id))
            return user
        }).map(u => u.name).join(', ')
      },
      react(name, type=''){
        if(this.$props.readonly === false){
          this.store.updateMessageReactions(this.message.id, { name: name, type: type }).then(({}) => {
            this.sendMetricComponent('react_message')
            this.success()
          })
        }
      },
      success() {
        this.$emit('success')
      },
      sendMetricComponent(name){
        let metric_name = 'file_communication_record_modal_'+name

        if(this.resource == 'RecordMessageShow')
          metric_name = 'file_communication_show_'+name

        this.store.sendMetrics({name: metric_name, params: this.$route.params, path: this.$route.fullPath})
      }
    }
  }
</script>
<style lang="sass" scoped>
  .emo, .emo i
    color: #686868 !important
  .readonly
    cursor: default !important
</style>
